'use client'

import { ReactNode } from 'react'

import { UserProvider } from '@/app/contexts/UserContext'

export function ClientProviders({ children }: { children: ReactNode }) {
  return <UserProvider>{children}</UserProvider>
}
